/* eslint-disable import/no-cycle */
import API from './api';
import { normalizarEscopoAmbiente } from './escopoAmbiente';

export const getEscopoUsuario = params =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/escopo-usuario`, params);

export const getLogin = params =>
  API.post(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/login`, params);

export const getEscopoAmbiente = () =>
  API.get(`${process.env.REACT_APP_API_CADASTRO_BASE_URL}/usuarios/escopo-ambiente`).then(response => ({
    ...response,
    data: normalizarEscopoAmbiente(response.data)
  }));
